import React from "react";
import Default from "./Default";

const Overview = () => {
    return (
        <Default />
    )
};

export default Overview;